import SymptomDate from './SymptomDate.jsx';

export default SymptomDate;